import { useQuery } from '@tanstack/react-query';
import { fetcher } from '../libs';

export type Career = {
  accountId: string;
  createdAt: string;
  detail: string;
  endAt: string | null;
  id: string;
  name: string;
  position: string | null;
  startAt: string;
  status: string;
  updatedAt: string;
};

export default function useCareersQuery() {
  return useQuery(['careers'], async () => {
    return fetcher<Career[]>(`/careers`);
  });
}
